import { createSlice } from '@reduxjs/toolkit'

export const initialState = {
  open: false,
  title: undefined,
  message: '',
  param: undefined,
  confirmFunction: null,
  confirmFunction2: null,
}

export const dialogSlice = createSlice({
  name: 'base/dialog',
  initialState,
  reducers: {
    openDialogAction: (state, { payload: { message, title, param, confirmFunction, confirmFunction2 } }) => {
      {
        return {
          ...state,
          open: true,
          title: title,
          message: message,
          param: param,
          confirmFunction: confirmFunction,
          confirmFunction2: confirmFunction2
        }
      }
    },
    closeDialogActoin: (state) => {
      {
        return {
          ...state,
          open: false,
          title: undefined,
          message: '',
          confirmFunction: null,
          confirmFunction2: null,
        }
      }
    },
    confirmDialogActoin: (state, { payload: { param } }) => {
      return {
        ...state,
        param: param
      }
    },
  },
})

export const { openDialogAction, closeDialogActoin, confirmDialogActoin } = dialogSlice.actions

export default dialogSlice.reducer
